<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <b-tabs content-class="mt-3">
        <b-tab title="Attendance" active>
          <div class="p-15 pb-0">
            <div class="row">
              <div class="col-sm-6">
                <table>
                  <tr>
                    <td>
                      <a @click="exportGym()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                    </td>
                    <td>
                      <a v-if="getRoleId != '33'" @click="openPage('/gym_attendance/add')" class="btn-primary"><i
                          class="fas fa-plus-square "></i>Add</a>
                    </td>
                    <td>
                      <flat-pickr :config="exportConfig" @on-change="changeDateBooking" v-model="exportDates"
                        name="export_date_start" class="font-13"></flat-pickr>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col-sm-3">
                <div class="row">
                  <div class="col-sm-4 col-form-label text-right">
                    Branch
                  </div>
                  <div class="col-sm-8">
                    <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                      <option :value="null">Please select</option>
                      <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                    </b-form-select>
                  </div>
                </div>
              </div>
              <div class="col-sm-3 text-right">
                <div class="search-header">
                  <div class="custom-search-container">
                    <div class="input-group custom-search">
                      <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData"
                        class="form-control" placeholder="Search">
                      <span class="icon-magnifier icon-input-custom"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="mb-0">
          <div class="p-15 pt-0 table-responsive">
            <!-- Total Scanning in Day -->
            <h4 class="mt-10">Total Scanning</h4>
            <table class="table table-bordered w-100">
              <thead>
                <tr>
                  <th>Days</th>
                  <th v-for="day in days" :key="day">
                    {{ day }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <th>Total</th>
                  <td v-for="day in days" :key="day">
                    <template v-if="tableSummary[day] > 0">
                      <button v-on:click="showScanningDetail(day, 'showScanningDetail')">{{ tableSummary[day] || 0
                      }}</button>
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>

            <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered"
              :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
              <template v-slot:cell(name)="data">
                <!--          <template slot="name" slot-scope="data">-->
                <template v-if="data.item.member">
                  {{ data.item.member.first_name }} {{ data.item.member.last_name }}
                </template>
              </template>
              <template v-slot:cell(usia)="data">
                <template v-if="data.item.member">
                  {{ calculateAge(data.item.member.birthday) }}
                </template>
              </template>
              <template v-slot:cell(email)="data">
                <!--          <template slot="email" slot-scope="data">-->
                <template v-if="data.item.member">
                  {{ data.item.member.email }}
                </template>
              </template>
              <template v-slot:cell(phone_number)="data">
                <!--          <template slot="phone_number" slot-scope="data">-->
                <template v-if="data.item.member">
                  {{ data.item.member.phone_number }}
                </template>
              </template>
              <template v-slot:cell(time)="data">
                <!--          <template slot="time" slot-scope="data">-->
                {{ parseDateTime(data.item.created_at) }}
              </template>
              <template v-slot:cell(in)="data">
                <span>
                  {{ parseDateTime(data.item.gym[0].created_at) }}
                </span>

                <!--          <template slot="time" slot-scope="data">-->
                <!-- {{parseDateTime(data.item.created_at)}} -->
              </template>
              <template v-slot:cell(out)="data">
                <span v-if="data.item.gym.length > 1">
                  {{ parseDateTime(data.item.gym[data.item.gym.length - 1].created_at) }}
                </span>

                <!--          <template slot="time" slot-scope="data">-->
                <!-- {{parseDateTime(data.item.created_at)}} -->
              </template>
              <template v-slot:cell(gym_attend_manual_count)="data">
                <b-badge v-if="data.item.is_manual == 1" :variant="'success'">Yes</b-badge>
                <b-badge v-if="data.item.is_manual == 0" :variant="'warning'">No</b-badge>
              </template>
              <template v-slot:cell(action)="data">
                <template v-if="data.item.towel">
                  <b-btn v-if="getRoleId != '33'" size="sm" v-on:click="changeTowel(data.item, 'changeTowel')"
                    class="btn-table primary ml-5">
                    <i class="fas fa-scroll"></i> Towel
                  </b-btn>
                </template>

                <b-btn v-if="getRoleId != '33'" size="sm" v-on:click="deleteGymAttendance(data.item.id)"
                  class="btn-table danger ml-5">
                  <i class="fas fa-trash"></i> Delete
                </b-btn>
              </template>
            </b-table>
            <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
              @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
          </div>
        </b-tab>

        <!-- Only show if role is admin -->
        <template v-if="getRoleId == 1">
          <b-tab title="Report">
            <div class="p-15 pb-0">
              <div class="row">
                <div class="col-sm-9">
                  <table>
                    <tr>
                      <td>
                        <a @click="exportGymDetailScanning()" class="btn-primary mr-5"><i
                            class="far fa-file-alt mr-5"></i>Export</a>
                      </td>
                      <td>
                        <flat-pickr :config="exportConfig" @on-change="changeDateBooking" v-model="exportDates"
                          name="export_date_start" class="font-13"></flat-pickr>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="col-sm-3">
                  <div class="row">
                    <div class="col-sm-4 col-form-label text-right">
                      Branch
                    </div>
                    <div class="col-sm-8">
                      <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                        <option :value="null">Please select</option>
                        <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                      </b-form-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-15 pt-0 table-responsive">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed"
                responsive="sm" :items="itemsReport" :fields="fieldsReport" :current-page="reportCurrentPage">
              </b-table>
              <app-pagination class="pagination-custom mt-20" :current-page="reportCurrentPage"
                :total-pages="totalReportPage" @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
            </div>
          </b-tab>
        </template>
      </b-tabs>
    </div>

    <!-- Change Member Towel Modal -->
    <b-modal modal-class="modal-custom-image" hide-footer :ref="'changeTowel'" centered title="Change Towel">
      <div class="p-10">
        <hr class="short-line left mb-10 mt-20">
        <div class="row">
          <div class="col-md-12">
            <b-row class="mb-20">
              <b-col sm="3">
                <label>Towel</label>
              </b-col>
              <b-col sm="12">
                <div class="custom-search-select">
                  <model-select autocomplete="false" @input="onTowelChange" :options="optionsTowel"
                    class="border-bottom" name="towel" v-model="towel_id"></model-select>
                </div>
                <span class="error">{{ errors.first('ptSession.member_id') }}</span>
              </b-col>
            </b-row>
            <b-btn size="sm" v-on:click="onSubmitTowelChanged()" class="btn-table danger ml-5 pull-right">
              <i class="fas fa-trash"></i> Submit
            </b-btn>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- detail scan -->
    <b-modal modal-class="modal-custom" size="xl" hide-footer :ref="'showScanningDetail'" title="Detail">
      <div class="table-responsive p-10">
        <div class="p-10">
          <strong>Scanning Date : {{ tableSummarySelectedDateTxt }}</strong>
          <hr class="short-line left mb-10 mt-20">
          <div class="row">
            <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered"
              :small="small" :fixed="fixed" responsive="sm" :items="tableSummaryDetail" :fields="fields"
              :current-page="tableSummaryDetailcurrentPage">
              <template v-slot:cell(name)="data">
                <!--          <template slot="name" slot-scope="data">-->
                <template v-if="data.item.member">
                  {{ data.item.member.first_name }} {{ data.item.member.last_name }}
                </template>
              </template>
              <template v-slot:cell(email)="data">
                <!--          <template slot="email" slot-scope="data">-->
                <template v-if="data.item.member">
                  {{ data.item.member.email }}
                </template>
              </template>
              <template v-slot:cell(phone_number)="data">
                <!--          <template slot="phone_number" slot-scope="data">-->
                <template v-if="data.item.member">
                  {{ data.item.member.phone_number }}
                </template>
              </template>
              <template v-slot:cell(time)="data">
                <!--          <template slot="time" slot-scope="data">-->
                {{ parseDateTime(data.item.created_at) }}
              </template>
              <template v-slot:cell(in)="data">
                <span>
                  {{ parseDateTime(data.item.gym[0].created_at) }}
                </span>
              </template>
              <template v-slot:cell(out)="data">
                <span v-if="data.item.gym.length > 1">
                  {{ parseDateTime(data.item.gym[data.item.gym.length - 1].created_at) }}
                </span>
              </template>
              <template v-slot:cell(gym_attend_manual_count)="data">
                <b-badge v-if="data.item.is_manual == 1" :variant="'success'">Yes</b-badge>
                <b-badge v-if="data.item.is_manual == 0" :variant="'warning'">No</b-badge>
              </template>
            </b-table>
            <app-pagination class="pagination-custom mt-20" :current-page="tableSummaryDetailcurrentPage"
              :total-pages="totalTableSummaryDetail" @page-changed="pageChangedTableSummary" prev-text="Prev"
              next-text="Next" />
          </div>
        </div>
      </div>
    </b-modal>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="40" alt="">
        <br>
        <div class="title-loading color-white">Please wait...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import moment from 'moment'
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'gymAttendance',
  components: {
    'app-pagination': Pagination,
    ModelSelect,
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      tableSummary: {},
      tableSummarySelectedDate: null,
      tableSummarySelectedDateTxt: '',
      tableSummaryDetail: {},
      totalTableSummaryDetail: 0,
      tableSummaryDetailcurrentPage: 1,
      days: Array.from({ length: 31 }, (_, i) => i + 1),
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'usia',
          label: 'Age',
          sortable: false,
        },
        {
          key: 'member.membership.name',
          label: 'Membership Type',
          sortable: true
        },
        {
          key: 'advisor',
          label: 'Membership Advisor',
          sortable: false,
          formatter: (value, key, item) => {
            return item.member != null ? item.member.sales != null ? item.member.sales.fullname : '-' : '-'
          },
        },
        {
          key: 'status_membership',
          label: 'Membership Status',
          sortable: false,
          formatter: (value, key, item) => {
            return item.member != null ? item.member.membership_status != null ? item.member.membership_status.name : '-' : '-'
          },
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'phone_number',
          label: 'Phone Number',
          sortable: true
        },
        {
          key: 'date_in',
          label: 'Date In',
          sortable: false,
          formatter: (value, key, item) => {
            // show in date
            return item.gym.length > 0 ? moment(item.gym[0].created_at).format('DD MMM YYYY') : '-'
          },
        },
        {
          key: 'in_time',
          label: 'Time In',
          sortable: false,
          formatter: (value, key, item) => {
            // show in date
            return item.gym.length > 0 ? moment(item.gym[0].created_at).format('HH:mm:ss') : '-'
          },
        },
        {
          key: 'date_out',
          label: 'Date Out',
          sortable: false,
          formatter: (value, key, item) => {
            // show out date
            return item.gym.length > 1 ? moment(item.gym[item.gym.length - 1].created_at).format('DD MMM YYYY') : '-'
          },
        },
        {
          key: 'time_out',
          label: 'Time Out',
          sortable: false,
          formatter: (value, key, item) => {
            // show out date
            return item.gym.length > 1 ? moment(item.gym[item.gym.length - 1].created_at).format('HH:mm:ss') : '-'
          },
        },
        {
          key: 'branch.name',
          label: 'Branch Name',
          sortable: false
        },
        {
          key: 'gym_attend_manual_count',
          label: 'Manual Attend',
          sortable: false
        },
        {
          key: 'towel.towel.name',
          label: 'Towel',
          sortable: false,
          formatter: (value, key, item) => {
            return item.towel != null ? item.towel.towel.name : '-'
          },
        },
        {
          key: 'total_att',
          label: 'Total Attendance',
          sortable: false
        },
        {
          key: 'total_pt',
          label: 'Total PT',
          sortable: false
        },
        {
          key: 'total_class',
          label: 'Total Class',
          sortable: false
        },
        {
          key: 'member.membership_expired_date',
          label: 'Membership Expired Date',
          sortable: false,
          formatter: (value, key, item) => {
            return item.member != null ? item.member.membership_expired_date != null ? moment(item.member.membership_expired_date).format('DD MMM YYYY') : '-' : '-'
          },
        },
        {
          key: "action",
          label: "Action",
          sortable: false
        }
      ],
      fieldsReport: [
        {
          key: 'member_id',
          label: 'Member ID',
          sortable: false
        },
        {
          key: 'member_name',
          label: 'Member Name',
          sortable: false
        },
        {
          key: 'branch_name',
          label: 'Branch Name',
          sortable: false
        },
        {
          key: 'month',
          label: 'Month',
          sortable: false
        },
        {
          key: 'total_scan',
          label: 'Total Attendance',
          sortable: false
        }
      ],
      totalReportItems: 0,
      reportCurrentPage: 1,
      reportPaginationLimit: 10,
      totalReportPage: 0,
      itemsReport: [],
      items: [],
      dataBranch: [],
      itemMember: [],
      branch_id: null,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD')) + ' to ' + (moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
      },
      optionsTowel: [],
      towel_id: null,
      towel_member_id: null,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role
    }
  },
  computed: {
    name() {
      return this.$route.name
    }
  },
  methods: {
    changeTowel(data, id) {
      this.towel_member_id = data.member_id
      this.$refs[id].show()
    },
    showScanningDetail(data, id) {
      this.tableSummarySelectedDate = data
      let cutDate = this.exportDates.split(' to ')
      // data is 1 until 31
      const tanggal = `${moment(cutDate[0]).format('YYYY-MM')}-${String(data).padStart(2, "0")}`;
      this.tableSummarySelectedDateTxt = moment(tanggal).format('DD MMMM YYYY')

      this.loadingActive = true

      let url = 'fitness/v1/history/gym_attendance_menu?page=' + this.tableSummaryDetailcurrentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start_date=' + tanggal
        + '&end_date=' + tanggal

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      axios.get(url).then(response => {
        this.loadingActive = false
        this.tableSummaryDetail = response.data.data.rows
        this.totalTableSummaryDetail = response.data.meta.pageCount
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      this.$refs[id].show()
    },
    onTowelChange(event) {
      console.log(event)
    },
    onSubmitTowelChanged() {
      this.$swal({
        title: "Are you sure?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Change it!",
        cancelButtonText: "No, Keep it!",
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then(result => {
        if (result.value) {
          const body = {
            member_id: this.towel_member_id,
            towel_id: this.towel_id
          }
          axios.post("mobile/v1/my_towel", body)
            .then(response => {
              this.$swal(
                "Changed",
                "You successfully changed this Towel",
                "success"
              );
              this.fetchData();
              this.$refs['changeTowel'].hide()

            }).catch(error => {
              console.log("error", error);
            });
        } else {
          this.$swal("Cancelled", "Member Towel is still intact", "info");
        }
      })
    },
    deleteGymAttendance(id) {
      console.log(id)
      this.$swal({
        title: "Are you sure?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Delete it!",
        cancelButtonText: "No, Keep it!",
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then(result => {
        if (result.value) {
          axios.delete('fitness/v1/member_gym_attendance/' + id).then(response => {
            this.$swal(
              "Deleted",
              "You successfully deleted this file",
              "success"
            );
            this.fetchData();
          }).catch(error => {
            console.log("error", error);
          });
        } else {
          this.$swal("Cancelled", "Your file is still intact", "info");
        }
      })
    },
    changeDateBooking(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      if (selectedDates.length === 2) {
        if (typeof selectedDates[0] === typeof selectedDates[1]) {
          this.exportDates = dateStr + ' to ' + dateStr
        } else {
          this.exportDates = dateStr
        }
        if (this.exportDates.includes(" to ") === true) {
          this.fetchData()
        }
      }
    },
    parseDateTime(value) {
      moment.locale('id')
      return moment(value).format('dddd, DD-MM-YYYY, HH:mm')
    },
    parseTime(value) {
      return (value).slice(0, -3)
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    pageChangedReport(pageNum) {
      this.reportCurrentPage = pageNum
    },
    pageChangedTableSummary(pageNum) {
      this.tableSummaryDetailcurrentPage = pageNum

      let cutDate = this.exportDates.split(' to ')
      // data is 1 until 31
      const tanggal = `${moment(cutDate[0]).format('YYYY-MM')}-${String(this.tableSummarySelectedDate).padStart(2, "0")}`;
      this.tableSummarySelectedDateTxt = moment(tanggal).format('DD MMMM YYYY')

      this.loadingActive = true

      let url = 'fitness/v1/history/gym_attendance_menu?page=' + this.tableSummaryDetailcurrentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start_date=' + tanggal
        + '&end_date=' + tanggal

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      axios.get(url).then(response => {
        this.loadingActive = false
        this.tableSummaryDetail = response.data.data.rows
        this.totalTableSummaryDetail = response.data.meta.pageCount
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked(searchEvent) {
      this.fetchData()
    },
    getBadge(status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    parseImg(value) {
      return Auth.apiUrl + 'fitness/v1/img/member/' + value
    },
    getRowCount(items) {
      return items.length
    },
    openPage(event) {
      this.$router.push(event)
    },
    editBlogCategory(event) {
      this.$router.push(event)
    },
    showModal(id) {
      this.$refs[id].show()
    },
    changeBranch(event) {
      this.loadingActive = true
      let cutDate = this.exportDates.split(' to ')
      let endDate = cutDate[1] == undefined ? cutDate[0] : cutDate[1]
      let url = 'fitness/v1/history/gym_attendance?page=' + this.currentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start_date=' + cutDate[0]
        + '&end_date=' + endDate

      if (event != null) {
        url += '&branch_id=' + event
      }

      axios.get(url).then(response => {
        this.loadingActive = false
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      this.branch_id = this.branch_id == null ? "" : this.branch_id
      axios.get('fitness/v1/history/gym_attendance_menu_total_scan?start_date=' + cutDate[0] + '&end_date=' + cutDate[1] + '&branch_id=' + this.branch_id + '').then(response => {
        this.tableSummary = response.data[0]
      }).catch(error => {
        console.log('error', error)
      })

      // report
      if (this.getRoleId == 1) {
        axios.get(`crm/v1/report/how_many_scan?branch_id=${this.branch_id}&page=${this.reportCurrentPage}&limit=${this.reportPaginationLimit}&start_date=${cutDate[0]}&end_date=${cutDate[1]}`).then(response => {
          this.itemsReport = response.data.data.rows
          this.totalReportPage = response.data.meta.pageCount
        }).catch(error => {
          console.log('error', error)
        })
      }
    },
    calculateAge(birthDate) {
      const today = new Date();
      const dob = new Date(birthDate);

      let age = today.getFullYear() - dob.getFullYear();

      const monthDiff = today.getMonth() - dob.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < dob.getDate())
      ) {
        age--;
      }

      return age;
    },
    fetchData() {
      this.loadingActive = true
      let cutDate = this.exportDates.split(' to ')
      let endDate = cutDate[1] == undefined ? cutDate[0] : cutDate[1]
      let url = 'fitness/v1/history/gym_attendance_menu?page=' + this.currentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start_date=' + cutDate[0]
        + '&end_date=' + endDate

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      axios.get(url).then(response => {
        this.loadingActive = false
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      this.branch_id = this.branch_id == null ? "" : this.branch_id

      // report
      if (this.getRoleId == 1) {
        axios.get(`crm/v1/report/how_many_scan?branch_id=${this.branch_id}&page=${this.reportCurrentPage}&limit=${this.reportPaginationLimit}&start_date=${cutDate[0]}&end_date=${cutDate[1]}`).then(response => {
          this.itemsReport = response.data.data.rows
          this.totalReportPage = response.data.meta.pageCount
        }).catch(error => {
          console.log('error', error)
        })
      }

      axios.get('fitness/v1/history/gym_attendance_menu_total_scan?start_date=' + cutDate[0] + '&end_date=' + cutDate[1] + '&branch_id=' + this.branch_id + '').then(response => {
        this.tableSummary = response.data[0]
      }).catch(error => {
        console.log('error', error)
      })

      // towel
      axios.get("mobile/v1/my_towel/get_list_towel?page=1&limit=20&member_id=").then(response => {
        this.optionsTowel = [];
        this.optionsTowel.push({ value: null, text: "Please select" })
        for (let i = 0; i < response.data.data.rows.length; i++) {
          const el = response.data.data.rows[i];
          this.optionsTowel.push({ value: el.id, text: el.name })
        }
      })
        .catch(error => {
          console.log("error", error);
        });
    },
    exportGym() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      let url = 'fitness/v1/export/gym_attendance?start_date=' + dates[0]
        + '&end_date=' + dates[1]
        + '&keyword=' + this.searchData

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Gym Attendance Report ' + moment(dates[0]).format('DD MMM YYYY') + ' - ' + moment(dates[1]).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    exportGymDetailScanning() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      this.branch_id = this.branch_id == null ? "" : this.branch_id
      let url = `crm/v1/export/report/how_many_scan?branch_id=${this.branch_id}&page=&limit=&start_date=${dates[0]}&end_date=${dates[1]}`

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Gym Total Attendance Report ' + moment(dates[0]).format('DD MMM YYYY') + ' - ' + moment(dates[1]).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style></style>
